import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import config from 'config'
import { useAuth } from 'hooks/AuthProvider'

type GuestGuardProps = {
  children: React.ReactNode
}

function GuestGuard({ children }: GuestGuardProps) {
  const navigate = useNavigate()

  // const searchParams = useSearchParams()
  const returnTo = config.defaultPath

  const { isAuthenticated, isLoading } = useAuth()

  const [isChecking, setIsChecking] = useState<boolean>(true)

  const checkPermissions = async (): Promise<void> => {
    if (isAuthenticated) {
      navigate(returnTo, { replace: true })
      return
    }
    setIsChecking(false)
  }

  useEffect(() => {
    checkPermissions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isLoading])

  if (isChecking) {
    return <h1>Cargando...</h1>
  }

  return <>{children}</>
}

export default GuestGuard
